import { Card, Flex, IconChevronRight, Paragraph, TextButton } from '@zillow/constellation';

import { StyledTourCard } from './StyledComponents';
import { LoadingParagraph, LoadingText } from '@zg-rentals/loading-components';

import type { Tour } from '../../../../constants/UpcomingToursConstants';

type BookedToursSectionProps = {
  inquiriesPath: string;
  onCalendarClick: () => void;
  tours: Array<Tour>;
  tourCalendarPath: string;
  isLoading: boolean;
  eventId?: string;
};

const BookedToursSection = ({
  inquiriesPath,
  onCalendarClick,
  tours,
  tourCalendarPath,
  isLoading,
  eventId,
}: BookedToursSectionProps) => {
  const buttonText = tours.length > 3 ? `+ ${tours.length - 3} more tours` : 'View calendar';
  const calendarButton = (
    <LoadingText isLoading={isLoading} loadingWidth="100%">
      <TextButton
        as="a"
        fontType="bodySmall"
        data-testid="UpcomingTours-calendarButton"
        onClick={onCalendarClick}
        href={tourCalendarPath}
        data-eventid={eventId}
      >
        {buttonText}
      </TextButton>
    </LoadingText>
  );

  if (tours.length === 0) {
    return (
      <Flex display="flex" flexDirection="column" gap={{ default: 'sm', lg: 'md' }}>
        <Card data-testid="UpcomingTours-noToursCard" cardElevation={0} cardType="secondary">
          <LoadingParagraph isLoading={isLoading} loadingWidth="100%">
            <Paragraph fontType={{ default: 'bodySmallHeading', lg: 'bodyHeading' }}>No tours for this date</Paragraph>
          </LoadingParagraph>
          <LoadingParagraph isLoading={isLoading} loadingWidth="100%">
            <Paragraph fontType="bodySmall">Booked tours will appear here.</Paragraph>
          </LoadingParagraph>
        </Card>
        <Flex>{calendarButton}</Flex>
      </Flex>
    );
  }

  return (
    <Flex display="flex" flexDirection="column" gap={{ default: 'sm', lg: 'md' }}>
      <Flex display="flex" flexDirection="column" gap="sm">
        {tours.slice(0, 3).map((tour: Tour) => (
          <StyledTourCard
            key={tour.tourId}
            data-testid="UpcomingTours-tourCard"
            cardElevation={0}
            cardDirection="left"
            onClick={() =>
              window.open(`${inquiriesPath}?conversationId=${tour.conversationId}`, '_blank', 'noopener, noreferrer')
            }
          >
            <Flex display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
              <Flex>
                <LoadingParagraph isLoading={isLoading} loadingWidth="100%">
                  <Paragraph fontType={{ default: 'bodySmallHeading', lg: 'bodyHeading' }}>{tour.tourName}</Paragraph>
                </LoadingParagraph>
                <LoadingParagraph isLoading={isLoading} loadingWidth="100%">
                  <Paragraph fontType="bodySmall">{tour.tourTime}</Paragraph>
                </LoadingParagraph>
              </Flex>
              <IconChevronRight fontColor="borderLight" />
            </Flex>
          </StyledTourCard>
        ))}
      </Flex>

      <Flex>{calendarButton}</Flex>
    </Flex>
  );
};

export default BookedToursSection;
